import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

// The search result carries a display-ready title (derived server-side from the
// first user message); this only supplies the fallback when it is absent.
export function displayChatTitle(title: string | null): string {
  return title && title.length > 0 ? title : 'Untitled chat'
}

export function formatChatDate(isoDate: string, now: dayjs.Dayjs = dayjs()): string {
  const date = dayjs(isoDate)
  const diffHours = now.diff(date, 'hour')

  if (diffHours < 24) {
    return date.from(now)
  }
  return date.format('MMM D, YYYY h:mm A')
}
